import { pathToRegexp } from "path-to-regexp";
import {
  NavigationItem,
  NavigationPageItem,
  NavigationSubheaderItem,
} from "../../types/types";

// const PERM_MENU_ITEMS = ["home", "sharepoint", "powerbi"];

const PERM_MENU_ITEMS = [
  "home",
  "orders",
  "loads",
  "quotes",
  "invoices",
  "sharepoint",
  "powerbi",
];

export const getItemKind = (item: NavigationItem) => item.kind ?? "page";

export const isPageItem = (item: NavigationItem): item is NavigationPageItem =>
  getItemKind(item) === "page";

export const isDividerItem = (item: NavigationItem) =>
  getItemKind(item) === "header";

export const canApplyFilter = (
  item: NavigationItem,
  applications: Array<string>,
): boolean =>
  isDividerItem(item) ||
  (item?.segment && PERM_MENU_ITEMS.includes(String(item?.segment))) ||
  (isPageItem(item) &&
    item?.segment &&
    applications?.includes(String(item?.segment)));

export const getItemTitle = (
  item: NavigationPageItem | NavigationSubheaderItem,
) => {
  return isPageItem(item) ? (item.title ?? item.segment ?? "") : item.title;
};

export function getPageItemFullPath(
  basePath: string,
  navigationItem: NavigationPageItem,
) {
  return `${basePath}${basePath && !navigationItem.router.path ? "" : "/"}${navigationItem.router.path ?? ""}`;
}

export function isPageItemSelected(
  navigationItem: NavigationPageItem,
  basePath: string,
  pathname: string,
) {
  return navigationItem.pattern
    ? pathToRegexp(`${basePath}${navigationItem.pattern}`).test(pathname)
    : getPageItemFullPath(basePath, navigationItem) === pathname;
}

export function hasSelectedNavigationChildren(
  navigationItem: NavigationItem,
  basePath: string,
  pathname: string,
): boolean {
  if (isPageItem(navigationItem) && navigationItem.children) {
    const navigationItemFullPath = getPageItemFullPath(
      basePath,
      navigationItem,
    );

    return navigationItem.children.some((nestedNavigationItem) => {
      if (!isPageItem(nestedNavigationItem)) {
        return false;
      }

      if (nestedNavigationItem.children) {
        return hasSelectedNavigationChildren(
          nestedNavigationItem,
          navigationItemFullPath,
          pathname,
        );
      }

      return isPageItemSelected(
        nestedNavigationItem,
        navigationItemFullPath,
        pathname,
      );
    });
  }

  return false;
}
